import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import {
    BookingTravellerTicketService
} from "libraries/component/booking-information/components/booking-traveller-card/components/booking-traveller/components/booking-traveller-ticket/services/booking-traveller-ticket.service";


@NgModule({
    imports: [
        CommonModule
    ],
    providers: [
        BookingTravellerTicketService,
    ],
})
export class BookingTravellerTicketServiceModule {
}
